import { render, staticRenderFns } from "./phone_verification_result_page.vue?vue&type=template&id=23adab87"
import script from "./phone_verification_result_page.vue?vue&type=script&lang=js"
export * from "./phone_verification_result_page.vue?vue&type=script&lang=js"
import style0 from "./phone_verification_result_page.vue?vue&type=style&index=0&id=23adab87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports